import React from "react";
import PageWrapper from "../modules/PageWrapper";
import { useMemberDashboardQuery } from "../../../store/member/memberDashboard/memberDashboardSlice";
import { useGetTodayBirthdaysQuery } from "../../../store/member/memberBirthdaySlice";
import { useUser } from "../../../hooks";
import { useCompanyCapabilities } from "../../../hooks/useCompanyCapabilities";
import ActivityFeed from "../../../components/shared/ActivityFeed";
import { DashboardPage, SkeletonBlock } from "../../../components/Dashboard";
import MemberHomeView from "./MemberHomeView";
import LegacyMemberHome from "./LegacyHome";
import {
  firstNameOf,
  hasMemberHomeContract,
  unwrapMemberDashboard,
} from "./memberHomeModel";

function MemberHomeSkeleton() {
  return (
    <DashboardPage>
      <div className="dx-page" aria-busy="true" aria-label="Loading your dashboard">
        <div className="dx-full">
          <SkeletonBlock height={28} style={{ width: 260, marginBottom: 8 }} />
          <SkeletonBlock height={16} style={{ width: 180 }} />
        </div>
        <div className="dx-col">
          <SkeletonBlock height={150} style={{ borderRadius: 18 }} />
          <SkeletonBlock height={84} />
          <SkeletonBlock height={220} />
        </div>
        <div className="dx-col">
          <SkeletonBlock height={90} />
          <SkeletonBlock height={140} />
          <SkeletonBlock height={200} />
        </div>
      </div>
    </DashboardPage>
  );
}

/**
 * Member home. Draws from one request (/members/dashboard). If the backend has not been
 * updated with the combined fields yet, the previous page is shown so nothing breaks.
 */
export default function MemberHome() {
  const { data, isLoading } = useMemberDashboardQuery();
  const user = useUser();
  const { investment, marketplace, realEstate } = useCompanyCapabilities();
  const { data: birthdayData } = useGetTodayBirthdaysQuery();

  const dashboard = unwrapMemberDashboard(data);

  if (isLoading) {
    return (
      <PageWrapper title="Dashboard">
        <MemberHomeSkeleton />
      </PageWrapper>
    );
  }

  if (!hasMemberHomeContract(dashboard)) {
    return <LegacyMemberHome />;
  }

  const birthdays = Array.isArray(birthdayData?.data) ? birthdayData.data.length : 0;

  return (
    <PageWrapper title="Dashboard">
      <MemberHomeView
        dashboard={dashboard}
        firstName={firstNameOf(dashboard, user)}
        birthdaysToday={birthdays}
        capabilities={{ investment, marketplace, realEstate }}
        activity={
          <ActivityFeed
            guard="member"
            perPage={5}
            showFilters={false}
            showPagination={false}
            groupByDate
            compact
            emptyMessage="No updates yet."
          />
        }
      />
    </PageWrapper>
  );
}
